import React from "react";
import { Outlet, Route } from "react-router-dom";
import Header from "../pages/common/Header";
import Footer from "../pages/common/Footer";
import SellerSidebar from "../SellerDashboardPages/common/SellerSidebar";


const AdminRoute = () => {
  return (
    <>
      <Header />
      {/* <SellerSidebar />? */}
        <Outlet />
      {/* <Footer /> */}
    </>
  );
};

export default AdminRoute;
